import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './comment.reducer';

export const CommentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const commentEntity = useAppSelector(state => state.comment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="commentDetailsHeading">
          <Translate contentKey="rainspotApp.comment.detail.title">Comment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{commentEntity.id}</dd>
          <dt>
            <span id="message">
              <Translate contentKey="rainspotApp.comment.message">Message</Translate>
            </span>
          </dt>
          <dd>{commentEntity.message}</dd>
          <dt>
            <Translate contentKey="rainspotApp.comment.user">User</Translate>
          </dt>
          <dd>{commentEntity.user ? commentEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="rainspotApp.comment.mesh">Mesh</Translate>
          </dt>
          <dd>{commentEntity.mesh ? commentEntity.mesh.id : ''}</dd>
          <dt>
            <Translate contentKey="rainspotApp.comment.device">Device</Translate>
          </dt>
          <dd>{commentEntity.device ? commentEntity.device.id : ''}</dd>
          <dt>
            <Translate contentKey="rainspotApp.comment.neighborhood">Neighborhood</Translate>
          </dt>
          <dd>{commentEntity.neighborhood ? commentEntity.neighborhood.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/comment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/comment/${commentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CommentDetail;
